function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9334 2.88476L9.11524 1.06658C9.07263 1.02397 9.01493 1 8.95455 1H1.9091C1.40794 1 1 1.40771 1 1.9091V10.0909C1 10.5923 1.40794 11 1.9091 11H10.0909C10.5921 11 11 10.5923 11 10.0909V3.04546C11 2.98509 10.976 2.92737 10.9334 2.88476ZM3.27274 1.45454H8.27275V4.18181C8.27275 4.43238 8.06899 4.63635 7.81821 4.63635H3.72728C3.47647 4.63635 3.27274 4.43238 3.27274 4.18181V1.45454ZM9.18183 10.5455H2.81818V6.45455H9.18183V10.5455ZM10.5455 10.0909C10.5455 10.3415 10.3417 10.5455 10.0909 10.5455H9.63639V6.22727C9.63639 6.10165 9.53473 5.99999 9.40911 5.99999H2.59092C2.46529 5.99999 2.36364 6.10165 2.36364 6.22727V10.5455H1.9091C1.6583 10.5455 1.45456 10.3415 1.45456 10.0909V1.9091C1.45456 1.65853 1.65832 1.45456 1.9091 1.45456H2.8182V4.18184C2.81818 4.68321 3.22612 5.09091 3.72728 5.09091H7.81819C8.31935 5.09091 8.72729 4.68321 8.72729 4.18181V1.45454H8.86046L10.5455 3.13957V10.0909Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.83301 2.66602L6.83301 3.49935",
  stroke: "currentColor",
  strokeLinecap: "round"
});

function SvgSaveicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveicon);
export default __webpack_public_path__ + "static/media/save.icon.11fba732.svg";
export { ForwardRef as ReactComponent };